import { all, call, select, put, takeEvery } from 'redux-saga/effects';
import {
  PapiBadge,
  PapiDaUserProfileBadgesList,
  PapiRequestDaUserProfileBadgesList,
  PapiRequestDaUserProfileBadgesUpdateOrder,
} from '@wix/da-papi-types';
import { logBiEvent } from '@wix/da-shared-react/pkg/biLogger/redux/saga';
import { ReorderBadgeBiEvent, PureBiData } from '@wix/da-bi/pkg/events';
import {
  takeStreamFetch,
  fetchStreamContents,
} from '@wix/da-shared-react/pkg/Stream/helpers';
import { selectors, actions } from '@wix/da-shared-react/pkg/Stream';
import { request } from '@wix/da-shared-react/pkg/xhr';
import {
  fetchMoreBadges,
  moveBadgeToPosition,
  refreshBadgeModules,
} from '../actions/badges';
import { API_BASE_PATH } from '../../constants';
import { BADGES_STREAM } from '../streams';
import { findModules } from '../selectors/modules';
import { ModuleType } from '../../types/modules';
import { updateModule } from '../actions/modules';
import { BADGE_COUNT } from '../components/UserWidgets/BadgesSpotlight/constants';

function* handleFetchBadges(action: ReturnType<typeof fetchMoreBadges>) {
  const { streamId } = action.payload;
  yield fetchStreamContents<
    PapiRequestDaUserProfileBadgesList,
    PapiDaUserProfileBadgesList
  >({
    streamId,
    baseURL: API_BASE_PATH,
    url: '/badges/list',
    params: {},
    getStreamData: result => ({
      hasMore: false,
      items: result.results,
    }),
  });
}

function* handleMoveBadge(action: ReturnType<typeof moveBadgeToPosition>) {
  const { badgeId, position, moveType } = action.payload;
  const items: PapiBadge[] = yield select(selectors.getItems, BADGES_STREAM);
  const item = items.find(i => i.id === badgeId);

  if (!item) {
    return;
  }

  if (moveType === 'stream') {
    yield put(actions.moveItem({ streamId: BADGES_STREAM, item, position }));
    return;
  }

  const data: PapiRequestDaUserProfileBadgesUpdateOrder = {
    badgeid: badgeId,
    position,
  };

  yield call(request, {
    baseURL: API_BASE_PATH,
    method: 'post',
    url: '/badges/update_order',
    data,
  });
  const biData = PureBiData<ReorderBadgeBiEvent>({
    evid: 325,
    typeid_list: items.slice(0, BADGE_COUNT).map(b => b.typeId),
    badge_typeid: item.typeId,
  });
  yield call(logBiEvent, biData);
}

function* handleRefreshBadgeModules(action) {
  const items: PapiBadge[] = yield select(selectors.getItems, BADGES_STREAM);
  if (items.length === 0) {
    return;
  }
  const slicedBadges = items.slice(0, BADGE_COUNT);
  const modules = yield select(findModules, m =>
    [ModuleType.ABOUT, ModuleType.BADGES_SPOTLIGHT].includes(m.type)
  );
  const updateActions = modules.map(m =>
    put(
      updateModule({
        id: m.id,
        moduleData: {
          ...m.moduleData,
          badges: m.type === ModuleType.BADGES_SPOTLIGHT ? slicedBadges : items,
        },
      })
    )
  );
  yield all(updateActions);
}

export default function* rootBadgesSaga() {
  yield all([
    takeStreamFetch(fetchMoreBadges, handleFetchBadges),
    takeEvery(moveBadgeToPosition, handleMoveBadge),
    takeEvery(refreshBadgeModules, handleRefreshBadgeModules),
  ]);
}
